module.exports = __webpack_public_path__ + "img/3.29c1ce5b.png";